/* eslint-disable @typescript-eslint/camelcase */
import _ from 'lodash';
export var SuccessResponseCode = 0;
export var APINotAuthorizedResponseCode = 200;
export var APIAgreementResponseCode = 202;
export var APIAgreementResponseUpdateCode = 207;
export var NoAvailableSecurityChallengesResponseCode = 208;
export var SecurityChallengeFailedResponseCode = 209;
export var GenericErrorResponseCode = 99;
export var ApplicationDuplicateUsernameResponseCode = 600;
export var ApplicationDuplicateAccountTypeSSNResponseCode = 211;
export var ResponseCodes = {
  0: {
    name: 'Success',
    description: 'Request was successful'
  },
  98: {
    name: 'InvalidRequestParameters',
    description: 'One or more request parameters are invalid for this type of request'
  },
  99: {
    name: 'GenericError',
    description: 'Generic failure response for request'
  },
  100: {
    name: 'IncorrectUserOrPass',
    description: 'Username or password supplied when logging in was incorrect'
  },
  101: {
    name: 'FailedToDecryptUserPass',
    description: 'Password supplied could not be decrypted'
  },
  102: {
    name: 'FailedToDecryptMessage',
    description: 'Message supplied could not be decrypted'
  },
  103: {
    name: 'IncorrectEntity',
    description: 'Entity name supplied is incorrect'
  },
  104: {
    name: 'ExpiredRequest',
    description: 'Timestamp in login request is expired'
  },
  105: {
    name: 'FailedToParsePayload',
    description: 'Could not parse payload into correct parts'
  },
  106: {
    name: 'MessageIsNull',
    description: 'Message supplied was null'
  },
  107: {
    name: 'FailedToSplitMessage',
    description: 'Could not split message into required JWS parts'
  },
  108: {
    name: 'FailedToDecodeHeader',
    description: 'Could not decode header in JWS'
  },
  109: {
    name: 'FailedToDecodePayload',
    description: 'Could not decode payload in JWS'
  },
  110: {
    name: 'TooManyFailedLoginAttempts',
    description: 'There were too many unsuccessful login attempts for the given user'
  },
  111: {
    name: 'EndUserPasswordDoesNotMeetSecurityRequirements',
    description: "End user's password does not meet our current security requirements; password needs to be changed"
  },
  112: {
    name: 'EndUserPasswordIsTemporaryAndNeedsToBeChanged',
    description: "End user's password is a temporary password; password needs to be changed"
  },
  113: {
    name: 'EndUserPasswordIsExpired',
    description: 'Your password has expired as part of our annual security measures to keep your account safe. Please click the "Reset password" button below and follow the on-screen instructions to set a new password.'
  },
  114: {
    name: 'EndUserHasNoSecurityQuestions',
    description: 'Please contact Account Services at <a href="tel:18004940451">1-800-494-0451</a> to reset your login credentials.'
  },
  119: {
    name: 'AuthTokenDestructureFailed',
    description: 'Auth token destructure failed.'
  },
  200: {
    name: 'APINotAuthorizedForGivenRequest',
    description: 'API not authorized for given request'
  },
  202: {
    name: 'APIAgreementMissing',
    description: 'API Agreement is missing'
  },
  207: {
    name: 'AgreementMissing',
    description: 'Agreement is missing'
  },
  208: {
    name: 'NoAvailableSecurityChallenges',
    description: 'All security challenges have been marked as failed.'
  },
  209: {
    name: 'SecurityChallengeFailedVerification',
    description: 'Security challenge verification failed.'
  },
  211: {
    name: 'ApplicationDuplicateAccountTypeSSN',
    description: 'An account with this account type and SSN already exists. Please change the account type or reach out to Account Services at <a href="tel:18004940451">1-800-494-0451</a>.'
  },
  300: {
    name: 'Order error',
    description: function description(message) {
      return message;
    }
  },
  301: {
    name: 'Margin check error',
    description: function description(message) {
      return _.replace(message, 'Margin check error.', '');
    }
  },
  302: {
    name: 'Restricted symbol',
    description: 'This symbol is currently not allowed for trading.'
  },
  305: {
    name: 'Order placement error',
    description: 'Order Validation Error'
  },
  307: {
    name: 'Leveraged, Inverse, or Commodity ETF Warning',
    description: "Warning: Leveraged, Inverse, and Commodity ETFs carry unique risks and may not be suitable for all investors. <a href=\"https://legacy.tradingblock.com/docs/Agreements/Leveraged_Inverse_Commodity_ETF_Disclosure.pdf\" target=\"_blank\">CLICK HERE</a> to learn more. To proceed, click \"Bypass Warnings\"."
  },
  390: {
    name: 'Insufficient Funds',
    description: 'Insufficient funds to complete the requested operation.'
  },
  500: {
    name: 'AchRelationshipNotFound',
    description: 'The requested ACH relationship was not found.'
  },
  501: {
    name: 'AchRelationshipIsInInvalidStateForOperation',
    description: 'The requested ACH relationship is in a State that is invalid for the requested operation.'
  },
  502: {
    name: 'AchRelationshipApprovalMethodMismatch',
    description: 'The Approval Method specified in the operation does not match the Approval Method of the ACH relationship. Only MicroDeposit is currently supported.'
  },
  503: {
    name: 'TransferBeneficiaryNotFound',
    description: 'The requested transfer beneficiary was not found.'
  },
  504: {
    name: 'TransferIntermediaryNotFound',
    description: 'The requested transfer intermediary was not found.'
  },
  505: {
    name: 'TransferRecipientBankNotFound',
    description: 'The requested transfer recipient bank was not found.'
  },
  506: {
    name: 'TransferNotFound',
    description: 'The requested transfer was not found.'
  },
  507: {
    name: 'TransferIsInInvalidStateForOperation',
    description: 'The requested transfer is in a State that is invalid for the requested operation.'
  },
  508: {
    name: 'CashieringRequestFailedValidation',
    description: 'The Cashiering request failed validation.'
  },
  509: {
    name: 'TransferBeneficiaryMechanismMismatch',
    description: 'The transfer beneficiary Mechanism specified in the operation does not match the Mechanism of the transfer.'
  },
  510: {
    name: 'TransferApprovalWithUnapprovedAchRelationshipFailed',
    description: 'Cannot approve this transfer as it has an unapproved ACH relationship. First approve the relationship before attempting to approve the transfer.'
  },
  511: {
    name: 'AchRelationshipDuplicate',
    description: 'This ACH relationship is a duplicate of an existing relationship.'
  },
  512: {
    name: 'AchRelationshipDeleteWithPendingTransfersFailed',
    description: 'Cannot delete this ACH relationship as it has pending transfers. Remove those first, before attempting to delete the relationship.'
  },
  550: {
    name: 'ApexSentinelServiceFailed',
    description: 'The Apex Sentinel service failed while processing the operation.'
  },
  600: {
    name: 'ApplicationDuplicateUsername',
    description: 'The Username you entered is already being used.'
  },
  702: {
    name: 'MiscellaneousFileUploadError',
    description: 'The file upload failed.'
  }
};